const survey_routes = {
  path: "/survey",
  name: "Survey",
  component: () => import("@/components/LayOut/Main"),
  meta: { requiresAuth: true },
  children: [
    {
      path: "survey_index",
      component: () => import('@/views/Survey/SurveyIndex'),
      meta: { requiresAuth: true },
    },
  ]
}

export default survey_routes;